// extracted by mini-css-extract-plugin
module.exports = {"title":"Categories_title__3xCnq","button":"Categories_button__XcuRf","gift-photo":"Categories_gift-photo__UXyTb"};